import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const Row = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;
